export default {
  active: [],
  inactive: [],
  user_with_permissions: [],
  isLoading: false
}
